import { Injectable, RendererFactory2, Renderer2 } from '@angular/core';
import isEmpty from 'lodash-es/isEmpty';

import { OVERFLOW_AUTO, OVERFLOW_HIDDEN } from '@app/modules/core/constants/dom.constants';

@Injectable()
export class DomManipulateService {

  private renderer: Renderer2;
  private _overflowY: string = '';
  private _previousOverflowY: string = '';
  private _position: string = '';

  constructor(
    private rendererFactory: RendererFactory2
  ) {
    this.renderer = this.rendererFactory.createRenderer(null, null);
  }

  get overflowY(): string {
    return this._overflowY;
  }

  get position(): string {
    return this._position;
  }

  get previousOverflowY(): string {
    return this._previousOverflowY;
  }

  set overflowY(value: string) {
    this._overflowY = value;
  }

  set position(value: string) {
    this._position = value;
  }

  set previousOverflowY(value: string) {
    this._previousOverflowY = value;
  }

  get isValidManipulateByPreviousOverflowY(): boolean {
    return !isEmpty(this.previousOverflowY) && this.previousOverflowY !== OVERFLOW_HIDDEN;
  }

  public setBodyScroll(state: boolean): void {
    if (!this.getWindow()) {
      return;
    }
    this.previousOverflowY = this.overflowY;
    if (state) {
      this.overflowY = OVERFLOW_AUTO;
    } else {
      this.overflowY = OVERFLOW_HIDDEN;
    }
    if (window) this.renderer.setStyle(document.body, 'overflow-y', this.overflowY);
  }

  public setBookingScroll(state: boolean): void {
    const container = document?.getElementsByTagName(
      'app-booking'
    )?.[0]?.shadowRoot?.querySelector<HTMLElement>('div.booking-container');
    if (!this.getWindow() || typeof container === 'undefined') {
      return;
    }
    if (state) {
      container.style.overflow = '';
    } else {
      container.style.overflow = OVERFLOW_HIDDEN;
    }
  }

  public setShowHeader(state: boolean): void {
    const header = document?.getElementsByTagName('app-header')?.[0]?.shadowRoot?.querySelector('header');
    if (!this.getWindow() || typeof header === 'undefined') {
      return;
    }
    if (state) {
      header.style.display = 'block';
    } else {
      header.style.display = 'none';
    }
  }

  public resetScrollPosition(): void {
    if (!this.getWindow()) {
      return;
    }
    window.scrollTo({ top: 0 });
  }

  private getWindow(): Window | undefined {
    if (typeof window === 'undefined') {
      return undefined;
    }
    return window;
  }
}
